<template>
  <div v-if="hasMessages" ref="topMessage" class="top-message-collection">
    <oie-message-bar
      v-for="message of messages"
      :id="message.id"
      :key="message.id"
      :text="message.text"
      :custom-icon="message.customIcon"
      :mobile-text="message.mobileText"
      :link-url="message.linkUrl"
      :link-text="message.linkText"
      :link-icon="message.linkIcon"
      :is-type="message.isType"
      :use-close-button="message.useCloseButton"
      :close-button-text="message.closeButtonText"></oie-message-bar>
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    rustyBrowserMessageBarId: 'rusty-browser-message-bar'
  }),
  computed: {
    hasMessages() {
      return this.messages && this.messages.length > 0
    },
    isBrowserRusty() {
      return window.navigator.userAgent.indexOf('MSIE 11') > -1 || window.navigator.userAgent.indexOf('Trident/7.0') > -1
    }
  },
  beforeMount() {
    if (this.isBrowserRusty) {
      this.messages.unshift({
        id: this.rustyBrowserMessageBarId,
        text: this.tStatic('rustyBrowserMessageBarText'),
        mobileText: this.tStatic('rustyBrowserMessageBarMobileText'),
        isType: 'info',
        useCloseButton: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.top-message-collection {
  position: relative;
  z-index: 1;
}

.top-message-collection > * {
  width: 100%;
}
</style>
